import { Component, Input } from '@angular/core';
import { ISalesInfoCardData } from '../../interface/interface';
import { CommonModule } from '@angular/common';
import { SkeletonLoaderComponent } from "../skeleton/skeleton.component";

@Component({
  selector: 'app-sales-info-card',
  standalone: true,
  imports: [CommonModule, SkeletonLoaderComponent],
  templateUrl: './sales-info-card.component.html',
  styleUrl: './sales-info-card.component.scss',
})
export class SalesInfoCardComponent {
  @Input() data!: ISalesInfoCardData;
  @Input() isLoading: boolean = false;
}
